class AriaListboxV2 extends HTMLElement {
  static observedAttributes = ["active"];

  constructor() {
    super();

    this.handleKeyDown = (e) => {
      if (!this.active) return;

      switch (e.code) {
        case "ArrowUp":
          e.preventDefault();
          this._previous();
          break;
        case "ArrowDown":
          e.preventDefault();
          this._next();
          break;
        case "Home":
          e.preventDefault();
          this._first();
          break;
        case "End":
          e.preventDefault();
          this._last();
          break;
        case "Space":
        case "Enter":
          const focused = this.focused[0];

          if (focused) {
            this._handleSelect(focused);
          }
          break;
        default:
          break;
      }
    };

    this.addEventListener("click", (e) => {
      const option = e.target.closest(
        '[role="option"]:not([aria-disabled="true"])',
      );
      if (!option) return;

      this._handleSelect(option);
    });

    if (this.inline) {
      const listbox = this.querySelector('[role="listbox"]');

      listbox.addEventListener("focus", (e) => {
        console.log(`e`, e);
        this.setAttribute("active", "");
      });
      listbox.addEventListener("blur", () => this.removeAttribute("active"));
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "active" && oldValue === null && newValue !== null) {
      this._focus(this.selected[0]);
    }
  }

  connectedCallback() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  get inline() {
    return this.hasAttribute("inline");
  }

  get active() {
    return this.hasAttribute("active");
  }

  get options() {
    return [
      ...this.querySelectorAll('[role="option"]:not([aria-disabled="true"])'),
    ];
  }

  get selected() {
    return [...this.querySelectorAll('[role="option"][aria-selected]')];
  }

  get focused() {
    return [...this.querySelectorAll('[role="option"][data-focused]')];
  }

  _handleSelect(option) {
    this.selected.forEach((el) => el.removeAttribute("aria-selected"));
    option.setAttribute("aria-selected", "true");
    this._setInputValue(option.dataset.value);
    option.dispatchEvent(
      new CustomEvent("aria-listbox:change", {
        bubbles: true,
        detail: { value: option.dataset.value },
      }),
    );
  }

  _setInputValue(value) {
    const input = this.querySelector("[data-input]");

    if (!input) return;

    input.value = value;
  }

  _first() {
    this._focus(this.options[0]);
  }

  _last() {
    const options = this.options;
    this._focus(options[options.length - 1]);
  }

  _next() {
    const options = this.options;
    const currentIndex = options.findIndex((el) =>
      el.hasAttribute("data-focused"),
    );
    const newIndex = Math.min(currentIndex + 1, options.length - 1);
    if (newIndex === currentIndex) return;

    this._focus(options[newIndex]);
  }

  _previous() {
    const options = this.options;
    const currentIndex = options.findIndex((el) =>
      el.hasAttribute("data-focused"),
    );
    const newIndex = Math.max(currentIndex - 1, 0);
    if (newIndex === currentIndex) return;

    this._focus(options[newIndex]);
  }

  _focus(el) {
    this.options.forEach((el) => {
      el.removeAttribute("data-focused");
    });
    if (!el) return;
    el.setAttribute("data-focused", "");
    el.dispatchEvent(
      new CustomEvent("aria-listbox:focus-change", {
        bubbles: true,
        detail: { value: el.dataset.value },
      }),
    );
  }
}

if (!customElements.get("aria-listbox-v2")) {
  customElements.define("aria-listbox-v2", AriaListboxV2);
}
